import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Breadcrumb.css";

const breadcrumbNameMap = {
  // Home and main
  "": "Home",
  "test-series": "Test Series",
  // Free PYQ
  "pyq": "Free Mock Tests",
  "jeemains": "JEE Mains PYQ",
  "jeeadv": "JEE Adv PYQ",
  "neet": "NEET PYQ",
  // Premium
  "jee-premium": "JEE Premium Tests",
  "neet-premium": "NEET Premium Tests",
  // Premium dynamic (from data)
  "jee_c11_chap": "JEE 11th Chapterwise",
  "jee_c12_chap": "JEE 12th Chapterwise",
  "jee_c11_full": "JEE 11th Full Syllabus",
  "jee_c12_full": "JEE 12th Full Syllabus",
  "jee_11_12_full": "JEE 11+12 Full Syllabus",
  "jee_aits": "JEE AITS",
  "jee_ultimate_combo": "JEE 3-in-1 Combo",
  "neet_c11_chap": "NEET 11th Chapterwise",
  "neet_c12_chap": "NEET 12th Chapterwise",
  "neet_c11_full": "NEET 11th Full Syllabus",
  "neet_c12_full": "NEET 12th Full Syllabus",
  "neet_11_12_full": "NEET 11+12 Full Syllabus",
  "neet_aits": "NEET AITS",
  "neet_ultimate_combo": "NEET 3-in-1 Combo",
  // Utility/other
  "inquiry-now": "Inquiry Now",
  "login": "Login",
  "signup": "Signup",
  "profile": "Profile",
  "purchased-tests": "My Purchased Tests",
  "admin": "Admin Panel",
  "dashboard": "Dashboard",
  // Static info
  "privacy-policy": "Privacy Policy",
  "terms-conditions": "Terms & Conditions",
  "refund-policy": "Refund Policy",
  "shipping-policy": "Shipping Policy",
  // Doubt portal (external link in nav)
  "doubt-portal24*7": "Doubt Portal 24×7",
};

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <nav className="breadcrumb">
      <span className="breadcrumb-item">
        🏠
      </span>

      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        const displayName = breadcrumbNameMap[name] || name.toUpperCase();

        return (
          <span key={index} className="breadcrumb-item">
            {isLast ? (
              <span className="active">{displayName}</span>
            ) : (
              <>
                <Link to={routeTo}>{displayName}</Link>
                <span className="separator">›</span>
              </>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
